'use client';
import React, { FC, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import 'swiper/css';
import 'swiper/css/autoplay';

import styles from './AdsSection.module.scss';
import NextImage from '@/src/components/ui/nextImage/NextImage';
import imageHelper from '@/src/lib/helpers/imageHelper';
import { ITheme } from '@/src/lib/types/themeInterface';
import ShopifyStoreButton from '@/src/components/ui/shopifyButton/ShopifyStoreButton';

type TAds = {
  themeData: ITheme;
};

type TDirection = 'vertical' | 'horizontal';

const AdsSection: FC<TAds> = ({ themeData }) => {
  const [direction, setDirection] = useState<TDirection>('vertical');

  useEffect(() => {
    const handleResize = () => {
      setDirection(window.innerWidth > 820 ? 'vertical' : 'horizontal');
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section>
      <Wrapper>
        <div className={styles.section__container}>
          <div className={styles.section__left}>
            <div className={styles.section__info}>
              {
                <h2 className={`heading__2 ${styles.heading}`}>
                  {themeData.ctaSectionTitle ?? ''}
                </h2>
              }
              {
                <p className={`excerpt ${styles.excerpt}`}>
                  {themeData.ctaSectionDescription ?? ''}
                </p>
              }
              <div className={styles.buttons}>
                <ShopifyStoreButton isWhite={false} theme={themeData} />
              </div>
            </div>
          </div>

          <Swiper
            modules={[Autoplay]}
            direction={direction}
            className={`${styles.swiper} gallery-autoplay-swiper`}
            slidesPerView={'auto'}
            initialSlide={0}
            allowTouchMove={false}
            shortSwipes={false}
            longSwipes={false}
            loop={true}
            autoplay={{
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
              delay: 0,
            }}
            spaceBetween={16}
            speed={15000}
            breakpoints={{
              1481: {
                spaceBetween: 24,
              },
            }}>
            {themeData.ctaGallery &&
              [...themeData.ctaGallery, ...themeData.ctaGallery].map((bg, i) => {
                return (
                  <SwiperSlide className={styles.background} key={`ads-background--${i}`}>
                    <NextImage
                      src={`${imageHelper(bg).url}`}
                      alt={`Background ${i}`}
                      fill
                      sizes="(max-width: 376px) 280px, (max-width: 480px) 320px, (max-width: 576px) 350px, (max-width: 820px) 480px, (max-width: 840px) 33.67vw, (max-width: 1480px) 35.44vw, (max-width: 1920px) 42.08vw, 808px"
                      loading="lazy"
                    />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      </Wrapper>
    </section>
  );
};

export default AdsSection;
